import { createContext, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [currentUser, setCurrentUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [invoices, setInvoices] = useState(null);

  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem("authToken");
    return storedToken ? JSON.parse(storedToken) : null;
  });

  useEffect(() => {
    if (!token) {
      setCurrentUser(null);
      setToken(null);
      localStorage.setItem("authToken", null);
    } else {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      axios
        .get("/api/verifyMyToken")
        .then((res) => {
          setCurrentUser(res.data.user);
          setOrganization(res.data.organization);
          setInvoices(res.data.invoices);
          localStorage.setItem("authToken", JSON.stringify(token));
          navigate(pathname);
        })
        .catch(() => {
          setCurrentUser(null);
          setOrganization(null);
          setInvoices(null);
          setToken(null);
          navigate("/login");
        });
    }
  }, [token]);

  const isAuthenticated = !!currentUser;

  return (
    <AuthContext.Provider
      value={{
        currentUser,
        setCurrentUser,
        organization,
        setOrganization,
        invoices,
        setInvoices,
        token,
        setToken,
        isAuthenticated,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
